import {
  FEATURES,
  OOREDOO_OFFER,
  GEORGIA_WINTER_COVER,
  TRAVEL_HOME_OFFER,
  QATAR_BOOKING_OFFER,
  NEW_LAYOUT_TRAVEL_WEBVIEW,
} from '@/shared/constants/features.constants'
import { initializeApp } from 'firebase/app'
import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
  setCustomSignals,
} from 'firebase/remote-config'
import { defineStore } from 'pinia'

const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: 'fb-web-qic.firebaseapp.com',
  projectId: 'fb-web-qic',
  storageBucket: 'fb-web-qic.firebasestorage.app',
  messagingSenderId: '76324519272',
  appId: '1:76324519272:web:c57028814ebaf5048f2add',
  measurementId: 'G-WFKYGFJCF9',
}

export const useFeaturesStore = defineStore('featuresStore', {
  state: () => ({
    features: {} as Record<string, boolean>,
    isOoredooEnabled: false,
    isGeorgiaWinterCoverEnabled: false,
    isTravelHomeOfferEnabled: false,
    isQatarBookingOfferEnabled: false,
    isNewLayoutTravelWebviewEnabled: false,
  }),
  getters: {
    getFeatureValue:
      (state) =>
      (feature: string): boolean =>
        state.features[feature] || false,
  },
  actions: {
    async fetchRemoteConfig() {
      try {
        const app = initializeApp(FIREBASE_CONFIG)
        const remoteConfig = getRemoteConfig(app)
        remoteConfig.settings.minimumFetchIntervalMillis = 3600000

        try {
          await setCustomSignals(remoteConfig, {
            env: process.env.NODE_ENV === 'production' ? window.location.hostname : 'dev',
          })
        } catch (error) {
          console.error('Error setting custom signals:', error)
        }

        await fetchAndActivate(remoteConfig)
        FEATURES.forEach((feature: string) => {
          this.features[feature] = getValue(remoteConfig, feature).asBoolean()
        })
        this.setIsOoredooEnabled()
        this.setIsGeorgiaWinterCoverEnabled()
        this.setIsTravelHomeOfferEnabled()
        this.setIsQatarBookingOfferEnabled()
        this.setIsNewLayoutTravelWebviewEnabled()
      } catch (error) {
        console.error('Error loading Remote Config:', error)
      }
    },
    setIsOoredooEnabled() {
      this.isOoredooEnabled = this.getFeatureValue(OOREDOO_OFFER) || false
    },
    setIsGeorgiaWinterCoverEnabled() {
      this.isGeorgiaWinterCoverEnabled = this.getFeatureValue(GEORGIA_WINTER_COVER) || false
    },
    setIsTravelHomeOfferEnabled() {
      this.isTravelHomeOfferEnabled = this.getFeatureValue(TRAVEL_HOME_OFFER) || false
    },
    setIsQatarBookingOfferEnabled() {
      this.isQatarBookingOfferEnabled = this.getFeatureValue(QATAR_BOOKING_OFFER) || false
    },
    setIsNewLayoutTravelWebviewEnabled() {
      this.isNewLayoutTravelWebviewEnabled =
        this.getFeatureValue(NEW_LAYOUT_TRAVEL_WEBVIEW) || false
    },
  },
})
